<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      :titulo="$t ('Festivos')"
      icono="mdi-calendar-star"
      tabla="fes"
      :campos="['dia', 'mes', 'nom+']"
      busqueda-rapida
      :titulo-crud="$t ('festivo')"
      permitir-anadir
      permitir-modificar
      permitir-eliminar
    />

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";

export default {
  components: { TablaDatosAPI }
};
</script>

<style>
</style>